import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const AppleFill = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.667.667S10.8 1.6 10 2.533c-.933.934-2 .8-2 .8s-.2-.8.6-1.666c.867-1 2.067-1 2.067-1ZM13 5.467s-1.4.733-1.4 2.466c0 1.934 1.667 2.667 1.667 2.667S12.067 14 10.4 14c-.733 0-1.333-.533-2.133-.533S6.667 14 6.133 14c-1.533 0-3.466-3.267-3.4-5.8 0-2.6 1.6-3.933 3.134-3.933 1 0 1.733.533 2.266.533.467 0 1.267-.6 2.334-.6C12.267 4.2 13 5.467 13 5.467Z"
      fill="currentColor"
    />
  </Icon>
));

export default AppleFill;
